import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Phone visitors who open davino.ai in a regular browser tab (not from the home-screen
// icon) are sent to /join, which explains how to add Davino to the home screen.
// "Continue in the browser for now" on that page sets davino_install_dismissed,
// which pauses this redirect for 7 days.
function shouldShowInstallGuide() {
  try {
    if (window.location.pathname !== "/") return false;
    if (window.location.search || window.location.hash) return false;
    const standalone = window.navigator.standalone === true ||
      window.matchMedia("(display-mode: standalone)").matches;
    if (standalone) return false;
    const ua = navigator.userAgent || "";
    const isIOS = /iPhone|iPad|iPod/.test(ua) ||
      (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
    const isAndroid = /Android/i.test(ua);
    if (!isIOS && !isAndroid) return false;
    const dismissed = parseInt(localStorage.getItem("davino_install_dismissed") || "0", 10);
    if (dismissed && Date.now() - dismissed < 7 * 24 * 60 * 60 * 1000) return false;
    return true;
  } catch (e) {
    return false;
  }
}

if (shouldShowInstallGuide()) {
  window.location.replace("/join");
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
